import script from "./message-input-editor-web.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-input-editor-web.vue?vue&type=script&setup=true&lang=ts"

import "./message-input-editor-web.vue?vue&type=style&index=0&id=6df82e8c&scoped=true&lang=scss"
import "./message-input-editor-web.vue?vue&type=style&index=1&id=6df82e8c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6df82e8c"]])

export default __exports__